
import Vue from 'vue';
import { appendPx } from '../Token/helper/tokenHelper';
import WebText from '../Text/Text.vue';
import ArrowDownLight from '../../Icons/ArrowDownLight.vue';
/**
 * InputList component.
 *
 * An input with dropdown values.
 */
class SearchObject {
  // body of constructor is not necessary
  constructor(public label: string, public value: any, public icon: string) {}
}
export default Vue.extend<any, any, any, any>({
  name: 'InputList',
  components: {
    ArrowDownLight,
    WebText
  },
  props: {
    /**
     * Arrow color of the Input List.
     */
    arrowFill: {
      type: String,
      default: '#bababa'
    },
    /**
     * Text variant of the Input List value.
     */
    variant: {
      type: String,
      default: 'ui-baseline'
    },
    /**
     * Text ink of the Input List value.
     */
    ink: {
      type: String,
      default: 'secondary'
    },
    /**
     * Placeholder of the Input List
     */
    placeholder: {
      type: String,
      default: ''
    },
    /**
     * Make font weight value of the Input List bold.
     */
    bold: {
      type: Boolean,
      default: true
    },
    /**
     * Make Input List disabled.
     */
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * Input List ref key.
     */
    inputRef: {
      type: String,
      default: ''
    },
    /**
     * Will not show any items on dropdown if Input is empty.
     */
    secondary: {
      type: Boolean,
      default: false
    },
    /**
     * Marks if this prop is given, all items will show on dropdown
     * even if prop secondary is given.
     */
    relatedValue: {
      type: String,
      default: ''
    },
    /**
     * The options list of the Input List.
     * Possible value structure:
     * `value: string; label: string; icon: string; blocked: boolean`
     * blocked means the selection cannot be selected and indicates as a static category
     */
    items: {
      type: Array,
      default: () => [
        {
          value: '',
          label: '',
          icon: '',
          blocked: false
        }
      ]
    },
    /**
     * The image URL callback when icon is not found.
     */
    errorImage: {
      type: [String, Object],
      default: null
    },
    /**
     * Left icon of the Input List.<br />
     * @type {VueComponent}
     */
    leftIcon: {
      default: null
    },
    /**
     * Arrow icon of the Input List.<br />
     * @type {VueComponent}
     */
    arrowIcon: {
      default: () => ArrowDownLight
    },
    /**
     * Color of the left icon.
     */
    iconFill: {
      type: String,
      default: '#e5e5e5'
    },
    /**
     * Size of the left icon.
     */
    iconSize: {
      type: Number,
      default: 24
    },
    /**
     * Size of the arrow icon.
     */
    arrowSize: {
      type: Number,
      default: 14
    },
    /**
     * The input result will only consist one data (value).
     */
    singleData: {
      type: Boolean,
      default: false
    },
    /**
     * The value of the Input List.
     */
    value: {
      default: false
    },
    /**
     * Will show all items and not filtered by the words on the current input.
     */
    ignoreRelated: {
      type: Boolean,
      default: false
    },
    /**
     * Border radius of the Input List
     */
    radius: {
      type: Number,
      default: 4
    },
    /**
     * Error state if the Input List
     */
    error: {
      type: Boolean,
      default: false
    },
    /**
     * The error message of the Input List
     */
    errormessage: {
      type: String,
      default: ''
    },
    /**
     * When search is empty, trigger the custom template.
     */
    useCustomEmptySearch: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      results: [],
      isOpen: false,
      currentSel: '',
      search: new SearchObject('', null, ''),
      labelItem: ''
    };
  },
  watch: {
    value(newVal: any) {
      if (newVal && this.singleData && this.items && this.items.length > 0) {
        let modNewVal = newVal.toString();
        const findData = (this.items as any[]).find(item => item.value.toString() === modNewVal);
        if (findData && modNewVal.length > 0) {
          this.labelItem = findData.label;
        } else {
          this.labelItem = '';
        }
      }
    }
  },
  methods: {
    onChange(e: Event) {
      const valueData = (e.target as HTMLInputElement).value;
      if (valueData.length < 1) {
        this.isOpen = false;
      }
      this.labelItem = valueData;
      this.isOpen = true;
      this.filterResults(valueData);
      this.$emit('change');
    },
    handleFocus(e: Event) {
      /**
       * Handle when Input List state in `focus`
       * @event focus
       * @type {function}
       */
      this.$emit('focus', e);
    },
    imgError(e: Event) {
      if (this.errorImage) {
        // @ts-ignore
        e.target.src = this.errorImage;
      }
    },
    setResult(result: SearchObject) {
      this.search = result;
      this.labelItem = result.label;
      let sendData;
      if (this.singleData) {
        this.currentSel = this.search.label;
        sendData = this.search.value;
      } else {
        this.currentSel = this.search;
        sendData = this.search;
      }
      /**
       * Handle when Input List change value
       * @event input
       * @type {function}
       */
      this.$emit('input', sendData);
      this.isOpen = false;
      this.results = [...this.items];
    },
    filterResults(value: String) {
      let input = value || '';
      let temp = this.items.slice(0) as any[];
      const results = temp.filter(item => {
        const defaultState = item.label.toLowerCase().indexOf(input.toLowerCase()) > -1;
        const isNotBlocked = value ? !item.blocked : true;
        return defaultState && isNotBlocked;
      });
      this.results = results;
    },
    deactivate(e: Event) {
      /**
       * Handle when Input List state in `blur`
       * @event blur
       * @type {function}
       */
      this.$emit('blur', e);
      setTimeout(() => {
        if (this.currentSel !== undefined) {
          if (this.singleData) {
            this.labelItem = this.currentSel;
          } else {
            this.labelItem = this.currentSel.label;
          }
        }
        (this.$el as HTMLElement).blur();
        this.isOpen = false;
      }, 150);
    },
    isDropDownOpen() {
      let value = this.value || '';
      if (value.length > 0) {
        if (this.ignoreRelated) {
          this.results = [...this.items];
        } else {
          this.filterResults(value);
        }
      } else {
        if (this.secondary && this.relatedValue.length < 1) {
          this.results = [];
        } else {
          this.results = [...this.items];
        }
      }
      if (!this.disabled) {
        this.isOpen = !this.isOpen;
      }
    },
    computedResultClass(blocked: boolean, label: string) {
      return {
        blocked,
        'autocomplete-result': true,
        selected: label === this.labelItem
      };
    }
  },
  computed: {
    inputRadius() {
      // @ts-ignore
      return appendPx(this.radius);
    }
  }
});
